//Accordion
(function ($) {
    function faq() {
        let faq = $('.faq');

        faq.each(function () {
            let accordionImageItem = $(this).find('.faq__question');
            let faqAnswer = $(this).find('.faq__answer');

            accordionImageItem.on('click', function(e) {

                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                    $(this).next(faqAnswer).slideUp(300);
                } else {
                    accordionImageItem.removeClass('active');
                    faqAnswer.slideUp(300);
                    $(this).next(faqAnswer).slideDown(300);
                    $(this).addClass('active');
                }
            });
        });

    }

    faq();
})(jQuery);